import { Component, OnInit, signal } from "@angular/core";
import { interval, Subscription } from "rxjs";
import { SystemServices } from "src/app/core/models/healthSystemService";
import { SynchpcServiceInfoWrapper } from "src/app/core/models/hostSynchpcService";
import { HealthService } from "src/app/core/services/health.service";
import { SyncConfigService } from "src/app/core/services/sync-config.service";

@Component({
  selector: "app-health-services",
  templateUrl: "./health-services.component.html",
  styleUrl: "./health-services.component.scss",
})
export class HealthServicesComponent implements OnInit {
  readonly panelOpenState = signal(false);
  constructor(
    private healthService: HealthService,
    public syncConfig: SyncConfigService
  ) {}

  synchpcService: SynchpcServiceInfoWrapper;
  systemService: SystemServices;
  dataReloadSubscription: Subscription;

  ngOnInit() {
    this.getHostSycnHpcService();
    this.getHostSystemService();
  }

  getHostSycnHpcService() {
    this.healthService.getHostSycnhpcServices().subscribe({
      next: (data: any) => {
        this.synchpcService = <SynchpcServiceInfoWrapper>(
          JSON.parse(JSON.stringify(data))
        );
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  getHostSystemService() {
    this.healthService.getHostSystemServices().subscribe({
      next: (data: any) => {
        this.systemService = <SystemServices>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.healthService.dataReqInterval
    ).subscribe(async () => {
      await this.getHostSycnHpcService();
      await this.getHostSystemService();
    });
  }
}
